import React from 'react';
import { ThemeBuilder as ThemeBuilderComponent } from '../components/ai/ThemeBuilder';

export const ThemeBuilderPage: React.FC = () => {
  return <ThemeBuilderComponent />;
};